import { createTheme } from '@mui/material/styles'
import { esES } from '@mui/material/locale'

// Sistema de diseño DPY Ágil — Inter + densidad ERP (refinamiento fino, v3).
const NAVY = '#212b55'
const CORAL = '#E2622C'
const BORDER = '#E4E7EC'
const MUTED = '#5F6B7E'

export const dpyTheme = createTheme(
  {
    palette: {
      primary: { main: NAVY, dark: '#161d3d', light: '#4d5382', contrastText: '#fff' },
      secondary: { main: CORAL, dark: '#C44E1E', light: '#FBEEE6', contrastText: '#fff' },
      background: { default: '#F6F7F9', paper: '#fff' },
      text: { primary: '#0F1A2B', secondary: MUTED, disabled: '#8A93A2' },
      divider: BORDER,
      error: { main: '#C0392B' },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      fontSize: 13,
      h1: { fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.02em' },
      h2: { fontSize: '1.25rem', fontWeight: 600, letterSpacing: '-0.015em' },
      h3: { fontSize: '1.0625rem', fontWeight: 600, letterSpacing: '-0.01em' },
      h4: { fontSize: '0.9375rem', fontWeight: 600 },
      h5: { fontSize: '0.875rem', fontWeight: 600 },
      h6: { fontSize: '0.8125rem', fontWeight: 600 },
      body1: { fontSize: '0.8125rem' },
      body2: { fontSize: '0.75rem' },
      caption: { fontSize: '0.6875rem' },
      button: { fontSize: '0.8125rem', textTransform: 'none', fontWeight: 600 },
    },
    components: {
      MuiTextField: { defaultProps: { size: 'small', variant: 'outlined' } },
      MuiSelect: { defaultProps: { size: 'small' } },
      MuiFormControl: { defaultProps: { size: 'small' } },
      MuiButton: {
        defaultProps: { size: 'small', disableElevation: true },
        styleOverrides: { root: { borderRadius: 8, paddingTop: 6, paddingBottom: 6 } },
      },
      MuiOutlinedInput: {
        styleOverrides: { root: { borderRadius: 6 }, input: { paddingTop: 8, paddingBottom: 8, fontSize: '0.8125rem' } },
      },
      MuiInputLabel: { styleOverrides: { root: { fontSize: '0.8125rem' } } },
      MuiChip: {
        defaultProps: { size: 'small' },
        styleOverrides: { root: { borderRadius: 6, height: 24, fontSize: '0.6875rem' } },
      },
      MuiTableCell: {
        styleOverrides: {
          root: { paddingTop: 8, paddingBottom: 8, fontSize: '0.8125rem' },
          head: { fontSize: '0.6875rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: MUTED, backgroundColor: '#F6F7F9' },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
          outlined: { borderColor: BORDER, boxShadow: '0 1px 2px rgba(15,26,43,.06)' },
        },
      },
    },
  },
  esES,
)

export const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace"
